import { render, staticRenderFns } from "./DeleteConfigurationComponentConfirm.vue?vue&type=template&id=da15323a&scoped=true&"
import script from "./DeleteConfigurationComponentConfirm.vue?vue&type=script&lang=ts&"
export * from "./DeleteConfigurationComponentConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da15323a",
  null
  
)

export default component.exports